import React, { useEffect } from "react"
import { AppWrapper } from "../components/AppWrapper"
import { BackgroundSection } from "../components/Background/BackgroundSection"
import Footer from "../components/ui/Footer"
import { FormContact } from "../components/FormContact/FormContact"
import { Header } from "../components/Header"
import { SeFormerHypnose } from "../components/SeFormerHypnose/SeFormerHypnose"
import bg from "../components/SeFormerHypnose/bg.webp"
import { SVGWave3 } from "../components/Background/SVGWave3"
import { WidthContainer } from "../components/WidthContainer"
import { useMobile } from "../hooks/hooks.js"
import firebase from "gatsby-plugin-firebase"
import { ANALYTIC_EVENT_NAMES } from "../constants/analytics"


export default function IndexPage({ location }) {
  const { mobile } = useMobile()

  // analytics - page viewed event
  useEffect(() => {
    if(!firebase) {
        return;
    }
    firebase.analytics().logEvent(ANALYTIC_EVENT_NAMES.web_page_viewed)
    firebase.analytics().logEvent(ANALYTIC_EVENT_NAMES.web_hypnosis_training_page_viewed)
  }, [firebase])

  return (
    <AppWrapper>
      <Header {...{ location: location.pathname }} />
      <div   {...{
        style: {
          background: `url(${bg})`,
          backgroundSize: "cover",
          color: "white",
          // margin: "36px 0"
        },
      }}>
        <WidthContainer center>
          <div id="" className="" {...{
            style: {
              width: mobile ? "" : "66%"
            },
          }}>
            <br />
            <br />
            <br />
            <br />
            <br />
            <div id="" className="" {...{ style: { fontSize: "36px", fontWeight: "700" }, }}>
              Se former à l’hypnose
            </div>
            <div id="" className="" {...{ style: { fontSize: "24px", fontWeight: "400" }, }}>
              Contrairement à certaines idées reçues, l’hypnose n’est pas un don, ni un pouvoir. L’hypnose c’est la maîtrise de techniques conversationnelles qui peuvent s’apprendre. Ci-dessous, retrouvez nos formations et ouvrages partenaires de qualité.
            </div>
            <br />
            <br />
            <br />
          </div>

          {/* <div id="" className="" {...{ style: { height: "200px" }, }}> */}

          {/* </div> */}

        </WidthContainer>
        <SVGWave3 style={{
          gridArea: "a",
          placeSelf: "end",
        }} {...{
          fill: "#CFE0EE",
        }} />
      </div>

      <BackgroundSection hypnose>
        <SeFormerHypnose />
        {/* <FormContact /> */}
      </BackgroundSection>
      <Footer />
    </AppWrapper>
  )
}